module.exports = __webpack_public_path__ + "img/outside.c592a87b.jpg";